import { render } from "./SiteNavigation.vue?vue&type=template&id=129403e6&scoped=true"
import script from "./SiteNavigation.vue?vue&type=script&lang=js"
export * from "./SiteNavigation.vue?vue&type=script&lang=js"

import "./SiteNavigation.vue?vue&type=style&index=0&id=129403e6&lang=scss&scoped=true"

import exportComponent from "/var/www/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-129403e6"]])

export default __exports__